export const REMOVE_ACCOUNT_USER_AND_FLUSH_USERS =
  "REMOVE_ACCOUNT_USER_AND_FLUSH_USERS";

export const UPDATE_ACCOUNT_USER_PERMISSIONS_AND_FLUSH_USERS =
  "UPDATE_ACCOUNT_USER_PERMISSIONS_AND_FLUSH_USERS";
